var _path, _path2, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-eh",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v256H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#007a3d",
    d: "M0 256h512v256H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 149.3h512v213.3H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#c4111b",
    d: "m0 0 256 256L0 512Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.7,
    transform: "translate(-135 -6.5) scale(1.02539)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 256,
    r: 68.3,
    fill: "#c4111b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 537.6,
    cy: 256,
    r: 68.3,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c4111b",
    d: "m493.7 297.3 29-20.8 29 21.2-10.8-34.2 29-21-35.8-.2-11-34-11.3 33.9-35.7-.1 28.7 21.2-11.1 34z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEh);
export default __webpack_public_path__ + "static/media/eh.be69ae1dfb2e13feb6afb4d95220186c.svg";
export { ForwardRef as ReactComponent };